import { render, staticRenderFns } from "./Facility.vue?vue&type=template&id=4457fb2c&scoped=true&"
import script from "./Facility.vue?vue&type=script&lang=js&"
export * from "./Facility.vue?vue&type=script&lang=js&"
import style0 from "./Facility.vue?vue&type=style&index=0&id=4457fb2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4457fb2c",
  null
  
)

export default component.exports